/* ============================================================================
FILE: po-katupirsia9-epagomene-texts-fr-en-es-20260327.js
MODE: protected trilingual with FR / EN / ES buttons + canonical lexicon preserved
API:  window.PoKatupirsia9EpagomeneTextsFR_EN_ES_20260327
ROOT: .po-axis-section[data-po-axis='epagomene']
ROLE:
  - Langue pilotée par localStorage : po_lex_lang + goody_gp_lang
  - Ré-injecte le contenu FR / EN / ES dans les slots
  - Maintient les entrées canoniques en français, y compris via protection fine
  - Ajoute une lecture audio générale et locale par bloc
  - N’altère ni l’architecture HTML, ni le nom du fichier, ni la logique de base
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_KATUPIRSIA9_EPAGOMENE_TEXTS_20260327__) return;
  window.__PO_KATUPIRSIA9_EPAGOMENE_TEXTS_20260327__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis='epagomene']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Epagomene_conceptuel.png?v=1773267604";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Epagomene_fonctionnel.png?v=1773267604";

  var CANON = {
    "title": "Epagomène",
    "plural": "Épagomènes",
    "singular_alt": "Epagomène",
    "plural_alt": "Epagomenes",
    "annee": "Année posœnnoïale",
    "decade": "Décade",
    "souffle": "Souffle d’Or",
    "triade": "3–6–9",
    "ap": "AP",
    "delta": "Δτ",
    "sceau": "Sceau d’Équiphase",
    "humanus": "Humanus",
    "manuscrit": "Katûpirsia 9 — Âṣẹxel’Or",
    "rituel": [
        "Air",
        "Feu",
        "Eau",
        "Terre",
        "Éther",
        "Libellule",
        "Phénix",
        "Sirène"
    ]
};

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s === "fr" || s.indexOf("fr") === 0) return "fr";
    if (s === "en" || s.indexOf("en") === 0) return "en";
    if (s === "es" || s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "es";
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function getBrowserLang(){
    var dl = document && document.documentElement ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    if (typeof navigator !== "undefined"){
      if (navigator.languages && navigator.languages.length) return normLang(navigator.languages[0] || "fr");
      if (navigator.language) return normLang(navigator.language || "fr");
    }
    return "fr";
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{ document.documentElement.setAttribute("lang", l); }catch(__e){}
    return l;
  }

  function getLang(){
    return readStoredLang() || getBrowserLang() || "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getTargetBlocks(){
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SEL) || []);
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k || seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    if (t.indexOf("/") !== -1){
      var parts = t.split("/");
      for (var i=0;i<parts.length;i++){
        var p = clampStr(parts[i]).trim();
        if (!p) continue;
        var vars = buildVariants(p);
        for (var j=0;j<vars.length;j++) uniqPush(out, vars[j], seen);
      }
    }
    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta &&
         Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}

    try{
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)){
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    }catch(e){}

    return [
      "Posœnnoïsme",
      "Katûpirsia",
      CANON.title,
      CANON.plural,
      CANON.singular_alt,
      CANON.plural_alt,
      CANON.annee,
      CANON.decade,
      CANON.humanus,
      CANON.souffle,
      CANON.ap,
      CANON.manuscrit,
      CANON.triade,
      CANON.delta,
      CANON.sceau,
      "Àṣẹxel’Or"
    ].concat(CANON.rituel);
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    var terms = [];
    var seen = Object.create(null);
    var extras = [
      CANON.title,
      CANON.plural,
      CANON.singular_alt,
      CANON.plural_alt,
      CANON.annee,
      CANON.decade,
      CANON.humanus,
      CANON.souffle,
      CANON.triade,
      CANON.ap,
      CANON.delta,
      CANON.sceau,
      CANON.manuscrit,
      "Katûpirsia 9",
      "Âṣẹxel’Or"
    ].concat(CANON.rituel);

    var all = base.concat(extras);
    for (var i=0;i<all.length;i++){
      var vars = buildVariants(all[i]);
      for (var j=0;j<vars.length;j++) uniqPush(terms, vars[j], seen);
    }

    terms.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<terms.length;k++) parts.push(escapeRegExp(terms[k]));
    if (!parts.length) return null;

    try{ return new RegExp("(" + parts.join("|") + ")", "g"); }
    catch(e){ return null; }
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function ensureProtectEngineReady(){
    var key = "fallback";
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        key = "meta:" + window.PO_LEXICON_META.lexique_simplifie_fr.length;
      }else if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        key = "meta2:" + window.PO_LEXICON.meta.lexique_simplifie_fr.length;
      }
    }catch(e){ key = "fallback"; }

    if (__PO_PROTECT_CACHE__.key === key && __PO_PROTECT_CACHE__.re) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;

    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(" "));

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(" "));

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;

    var walker;
    try{
      walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            var p = n.parentNode;
            var pn = p && p.nodeName ? p.nodeName : "";
            if (pn === "SCRIPT" || pn === "STYLE") return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return; }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return String(html); }

    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt);
    if (!s) return "";
    return "<p>" + escapeHTML(s).replace(/\n+/g, "</p><p>") + "</p>";
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
    protectKeywordsInElement(el);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    var s = clampStr(src);
    var a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt", ""); }catch(_e){}
      try{ el.style.display = "none"; }catch(__e){}
      return;
    }
    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(_e){}
    try{ el.style.display = ""; }catch(__e){}
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push("<li>" + protectKeywordsHTML(escapeHTML(arr[i])) + "</li>");
    el.innerHTML = out.join("");
    protectKeywordsInElement(el);
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = protectKeywordsHTML(escapeHTML(b.head || ""));
      var t = protectKeywordsHTML(clampStr(b.text || ""));
      out.push('<div class="po-axis-wb"><div class="po-axis-wb__h">' + h + '</div><div class="po-axis-wb__t">' + t + '</div></div>');
    }
    host.innerHTML = out.join("");
    protectKeywordsInElement(host);
  }

  var FALLBACK = {
    "fr": {
        "title": "Epagomène",
        "kicker": "Extrait de <em>Katûpirsia&nbsp;9 — Âṣẹxel’Or</em><br />(Seuil hors temps, redistribution du surplus et renaissance du cycle)",
        "h_def": "Définition opérative",
        "chips": [
            "Idéogramme conceptuel",
            "Idéogramme fonctionnel"
        ],
        "chip_urls": [
            CONCEPT_URL,
            FUNCTION_URL
        ],
        "def_short": "Seuil hors décades et hors mois : l’excès devient passage, redistribution et régénération.",
        "def_long": "<p>Dans <em>Katûpirsia&nbsp;9</em>, après douze mois de trente jours viennent cinq <span class=\"notranslate\" translate=\"no\">Épagomènes</span>, parfois six dans les années à amplitude élargie. Ils n’appartiennent ni aux décades ni aux mois : ils agissent comme seuils hors temps ordinaire, absorbent l’excédent et le transforment en espace de conscience.</p><p>Le corpus leur donne une fonction nette : convertir l’excès en passage. Chaque jour incarne un élément — Air, Feu, Eau, Terre, Éther — et se vit comme porte de régénération, de veille, de geste collectif ou de refondation. Les tableaux de l’<span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> leur donnent aussi une valeur vibratoire précise : souffle ultime, seuil d’infini, portails vers l’au-delà du temps.</p><p>Dans la logique du lexique, l’<span class=\"notranslate\" translate=\"no\">Epagomène</span> devient l’organe annuel de transmutation : là où un calendrier civil ajoute, <span class=\"notranslate\" translate=\"no\">AP</span> redistribue en conscience. Le surplus <span class=\"notranslate\" translate=\"no\">Δτ</span> y trouve un lieu d’accueil, le <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span> y règle la redistribution, et la triade <span class=\"notranslate\" translate=\"no\">3–6–9</span> y rejoint la relance du cycle.</p><p>Le terme est souvent formulé au pluriel dans le corpus, parce qu’il désigne le groupe des cinq ou six jours hors-cycle. Cette page retient le singulier <span class=\"notranslate\" translate=\"no\">Epagomène</span> comme seuil-type, pour faire apparaître la logique de chacun : un passage où l’année se défait pour renaître.</p>",
        "h_features": "Dynamiques opératives",
        "h_questions": "Applications / repères",
        "hint_fold": "déplier",
        "h_family": "Liens systémiques",
        "h_wordbuild": "Construction du terme",
        "features": [
            "Hors-cycle : l’<span class=\"notranslate\" translate=\"no\">Epagomène</span> n’appartient ni aux décades ni aux mois.",
            "Seuil de régénération : il accueille le surplus et le convertit en passage conscient.",
            "Portée élémentaire : Air, Feu, Eau, Terre, Éther modulent chacun un régime de transmutation.",
            "Souffle ultime : dans l’architecture annuelle, il ouvre l’année vers l’infini plutôt que vers une simple clôture.",
            "Redistribution consciente : le surplus <span class=\"notranslate\" translate=\"no\">Δτ</span> y devient respiration sacrée plutôt qu’ajout mécanique."
        ],
        "questions": [
            "Quel excédent, quel trop-plein ou quelle charge demande ici une redistribution plutôt qu’une suppression ?",
            "Quel élément domine le seuil vécu : ouverture, intensité, mémoire, ancrage ou expansion ?",
            "Quel geste bref rend le passage habitable : silence, offrande, décision, veillée, micro-rite ?",
            "Le seuil rencontré ferme-t-il le cycle, ou l’ouvre-t-il vers une relance plus vaste ?"
        ],
        "example_box": "<div><strong>Ex.</strong> À la fin d’un cycle de travail, réserver un temps bref pour redistribuer le trop-plein, nommer l’excès, l’offrir, puis franchir le seuil sans l’effacer : ce geste relève de la logique <span class=\"notranslate\" translate=\"no\">Epagomène</span>.</div>",
        "family_1": "<p><strong>Liens internes :</strong> <span class=\"notranslate\" translate=\"no\">Epagomène</span> est une sous-entrée de <span class=\"notranslate\" translate=\"no\">AP</span>. Il se relie directement à <span class=\"notranslate\" translate=\"no\">Δτ</span>, au <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span>, à la triade <span class=\"notranslate\" translate=\"no\">3–6–9</span>, à <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> et à <span class=\"notranslate\" translate=\"no\">Humanus</span>.</p>",
        "family_2": "<p><strong>Fonction systémique :</strong> dans l’architecture 36 + 5 de l’<span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span>, l’<span class=\"notranslate\" translate=\"no\">Epagomène</span> n’est pas un reste mais un organe de passage. Il recueille l’excès, le désature, le redistribue, puis ouvre la renaissance du cycle dans une respiration plus vaste.</p>",
        "word_blocks": [
            {
                "head": "1) Epagomène",
                "text": "Terme de calendrier désignant des jours “ajoutés” ; dans K9, l’ajout devient seuil et non supplément mécanique."
            },
            {
                "head": "2) Seuil",
                "text": "Le jour hors-cycle ne prolonge pas simplement la série : il crée un passage où le temps se défait, se redistribue et se relance."
            },
            {
                "head": "3) Organe annuel",
                "text": "L’<span class=\"notranslate\" translate=\"no\">Epagomène</span> devient le lieu où l’année transmute son excès et où la communauté peut renaître avec elle."
            }
        ],
        "word_notes": [
            "Le lexique atteste les formes : Épagomènes / Epagomenal Days / Epágomenos ; non affichées comme traduction du titre sur le site pour préserver l’élément canonique.",
            "Deux idéogrammes attestés : conceptuel et fonctionnel.",
            "Nombre canonique : 5, ou 6 selon amplitude.",
            "Fonction : convertir l’excès en passage et rendre le seuil habitable."
        ],
        "cta_translate": "Proposer une traduction du concept"
    },
    "en": {
        "title": "Epagomène",
        "kicker": "Excerpt from <em>Katûpirsia&nbsp;9 — Âṣẹxel’Or</em><br />(Threshold beyond ordinary time, redistribution of excess, and rebirth of the cycle)",
        "h_def": "Operative definition",
        "chips": [
            "Conceptual ideogram",
            "Functional ideogram"
        ],
        "chip_urls": [
            CONCEPT_URL,
            FUNCTION_URL
        ],
        "def_short": "Threshold beyond decades and months: excess becomes passage, redistribution, and regeneration.",
        "def_long": "<p>In <em>Katûpirsia&nbsp;9</em>, after twelve months of thirty days come five <span class=\"notranslate\" translate=\"no\">Épagomènes</span>, sometimes six in years of widened amplitude. They belong neither to decades nor to months: they act as thresholds beyond ordinary time, absorb the excess, and transform it into space of consciousness.</p><p>The corpus assigns them a clear function: to convert excess into passage. Each day embodies an element — Air, Fire, Water, Earth, Ether — and is lived as a gate of regeneration, vigil, collective gesture, or refoundation. The tables of the <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> also give them a precise vibratory value: ultimate breath, threshold of infinity, portals beyond time.</p><p>Within the logic of the lexicon, the <span class=\"notranslate\" translate=\"no\">Epagomène</span> becomes the annual organ of transmutation: where a civil calendar adds, <span class=\"notranslate\" translate=\"no\">AP</span> redistributes in consciousness. Surplus <span class=\"notranslate\" translate=\"no\">Δτ</span> finds there a place of reception, the <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span> regulates the redistribution, and the triad <span class=\"notranslate\" translate=\"no\">3–6–9</span> joins the relaunching of the cycle.</p><p>The term is often phrased in the plural in the corpus because it designates the group of five or six out-of-cycle days. This page keeps the singular <span class=\"notranslate\" translate=\"no\">Epagomène</span> as a threshold-type, so as to bring out the logic of each one: a passage in which the year comes undone in order to be reborn.</p>",
        "h_features": "Operative dynamics",
        "h_questions": "Applications / markers",
        "hint_fold": "expand",
        "h_family": "Systemic links",
        "h_wordbuild": "Term construction",
        "features": [
            "Out of cycle: the <span class=\"notranslate\" translate=\"no\">Epagomène</span> belongs neither to decades nor to months.",
            "Threshold of regeneration: it receives the excess and converts it into conscious passage.",
            "Elemental reach: Air, Fire, Water, Earth, Ether each modulate a regime of transmutation.",
            "Ultimate breath: within the annual architecture, it opens the year toward infinity rather than mere closure.",
            "Conscious redistribution: surplus <span class=\"notranslate\" translate=\"no\">Δτ</span> becomes sacred respiration rather than mechanical addition."
        ],
        "questions": [
            "What excess, overload, or charge calls here for redistribution rather than suppression?",
            "Which element governs the lived threshold: opening, intensity, memory, grounding, or expansion?",
            "Which brief gesture makes the passage inhabitable: silence, offering, decision, vigil, micro-ritual?",
            "Does the threshold encountered close the cycle, or open it toward a wider relaunch?"
        ],
        "example_box": "<div><strong>Ex.</strong> At the end of a work cycle, keeping a short time to redistribute the overload, name the excess, offer it, and then cross the threshold without erasing it belongs to the logic of <span class=\"notranslate\" translate=\"no\">Epagomène</span>.</div>",
        "family_1": "<p><strong>Internal links:</strong> <span class=\"notranslate\" translate=\"no\">Epagomène</span> is a sub-entry of <span class=\"notranslate\" translate=\"no\">AP</span>. It links directly with <span class=\"notranslate\" translate=\"no\">Δτ</span>, with the <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span>, with the triad <span class=\"notranslate\" translate=\"no\">3–6–9</span>, with <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span>, and with <span class=\"notranslate\" translate=\"no\">Humanus</span>.</p>",
        "family_2": "<p><strong>Systemic function:</strong> within the 36 + 5 architecture of the <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span>, the <span class=\"notranslate\" translate=\"no\">Epagomène</span> is not a leftover but an organ of passage. It receives the excess, desaturates it, redistributes it, and then opens the rebirth of the cycle into a wider respiration.</p>",
        "word_blocks": [
            {
                "head": "1) Epagomène",
                "text": "Calendar term designating “added” days; in K9, addition becomes threshold rather than mechanical supplement."
            },
            {
                "head": "2) Threshold",
                "text": "The out-of-cycle day does not merely extend the series: it creates a passage in which time comes undone, is redistributed, and is relaunched."
            },
            {
                "head": "3) Annual organ",
                "text": "The <span class=\"notranslate\" translate=\"no\">Epagomène</span> becomes the place where the year transmutes its excess and where the community can be reborn with it."
            }
        ],
        "word_notes": [
            "The lexicon attests the forms: Épagomènes / Epagomenal Days / Epágomenos; not displayed as a translated title on the site in order to preserve the canonical element.",
            "Two attested ideograms: conceptual and functional.",
            "Canonical number: 5, or 6 according to amplitude.",
            "Function: to convert excess into passage and make the threshold inhabitable."
        ],
        "cta_translate": "Suggest a translation of the concept"
    },
    "es": {
        "title": "Epagomène",
        "kicker": "Extracto de <em>Katûpirsia&nbsp;9 — Âṣẹxel’Or</em><br />(Umbral fuera del tiempo ordinario, redistribución del exceso y renacimiento del ciclo)",
        "h_def": "Definición operativa",
        "chips": [
            "Ideograma conceptual",
            "Ideograma funcional"
        ],
        "chip_urls": [
            CONCEPT_URL,
            FUNCTION_URL
        ],
        "def_short": "Umbral fuera de décadas y meses: el exceso se vuelve paso, redistribución y regeneración.",
        "def_long": "<p>En <em>Katûpirsia&nbsp;9</em>, después de doce meses de treinta días vienen cinco <span class=\"notranslate\" translate=\"no\">Épagomènes</span>, a veces seis en los años de amplitud ampliada. No pertenecen ni a las décadas ni a los meses: actúan como umbrales fuera del tiempo ordinario, absorben el exceso y lo transforman en espacio de conciencia.</p><p>El corpus les asigna una función clara: convertir el exceso en paso. Cada día encarna un elemento — Aire, Fuego, Agua, Tierra, Éter — y se vive como puerta de regeneración, vigilia, gesto colectivo o refundación. Los cuadros de la <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span> también les dan un valor vibratorio preciso: aliento último, umbral de infinito, portales más allá del tiempo.</p><p>En la lógica del léxico, el <span class=\"notranslate\" translate=\"no\">Epagomène</span> se convierte en el órgano anual de transmutación: allí donde un calendario civil añade, <span class=\"notranslate\" translate=\"no\">AP</span> redistribuye en conciencia. El excedente <span class=\"notranslate\" translate=\"no\">Δτ</span> encuentra allí un lugar de acogida, el <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span> regula la redistribución, y la tríada <span class=\"notranslate\" translate=\"no\">3–6–9</span> se une al relanzamiento del ciclo.</p><p>El término aparece a menudo en plural en el corpus porque designa el grupo de cinco o seis días fuera de ciclo. Esta página conserva el singular <span class=\"notranslate\" translate=\"no\">Epagomène</span> como umbral-tipo, para hacer visible la lógica de cada uno: un paso en el que el año se deshace para renacer.</p>",
        "h_features": "Dinámicas operativas",
        "h_questions": "Aplicaciones / referencias",
        "hint_fold": "desplegar",
        "h_family": "Vínculos sistémicos",
        "h_wordbuild": "Construcción del término",
        "features": [
            "Fuera de ciclo: el <span class=\"notranslate\" translate=\"no\">Epagomène</span> no pertenece ni a las décadas ni a los meses.",
            "Umbral de regeneración: recibe el exceso y lo convierte en paso consciente.",
            "Alcance elemental: Aire, Fuego, Agua, Tierra, Éter modulan cada uno un régimen de transmutación.",
            "Aliento último: en la arquitectura anual, abre el año hacia el infinito y no hacia un simple cierre.",
            "Redistribución consciente: el excedente <span class=\"notranslate\" translate=\"no\">Δτ</span> se vuelve respiración sagrada en lugar de adición mecánica."
        ],
        "questions": [
            "¿Qué exceso, saturación o carga exige aquí redistribución y no supresión?",
            "¿Qué elemento gobierna el umbral vivido: apertura, intensidad, memoria, anclaje o expansión?",
            "¿Qué gesto breve vuelve habitable el paso: silencio, ofrenda, decisión, vigilia o micro-rito?",
            "¿El umbral encontrado cierra el ciclo o lo abre hacia un relanzamiento más amplio?"
        ],
        "example_box": "<div><strong>Ej.</strong> Al final de un ciclo de trabajo, reservar un tiempo breve para redistribuir la saturación, nombrar el exceso, ofrecerlo y luego cruzar el umbral sin borrarlo pertenece a la lógica de <span class=\"notranslate\" translate=\"no\">Epagomène</span>.</div>",
        "family_1": "<p><strong>Vínculos internos:</strong> <span class=\"notranslate\" translate=\"no\">Epagomène</span> es una subentrada de <span class=\"notranslate\" translate=\"no\">AP</span>. Se vincula directamente con <span class=\"notranslate\" translate=\"no\">Δτ</span>, con el <span class=\"notranslate\" translate=\"no\">Sceau d’Équiphase</span>, con la tríada <span class=\"notranslate\" translate=\"no\">3–6–9</span>, con <span class=\"notranslate\" translate=\"no\">Souffle d’Or</span> y con <span class=\"notranslate\" translate=\"no\">Humanus</span>.</p>",
        "family_2": "<p><strong>Función sistémica:</strong> en la arquitectura 36 + 5 de la <span class=\"notranslate\" translate=\"no\">Année posœnnoïale</span>, el <span class=\"notranslate\" translate=\"no\">Epagomène</span> no es un resto sino un órgano de paso. Recoge el exceso, lo desatura, lo redistribuye y luego abre el renacimiento del ciclo en una respiración más amplia.</p>",
        "word_blocks": [
            {
                "head": "1) Epagomène",
                "text": "Término calendárico que designa días “añadidos”; en K9, la adición se vuelve umbral y no suplemento mecánico."
            },
            {
                "head": "2) Umbral",
                "text": "El día fuera de ciclo no prolonga simplemente la serie: crea un paso donde el tiempo se deshace, se redistribuye y se relanza."
            },
            {
                "head": "3) Órgano anual",
                "text": "El <span class=\"notranslate\" translate=\"no\">Epagomène</span> se vuelve el lugar donde el año transmuta su exceso y donde la comunidad puede renacer con él."
            }
        ],
        "word_notes": [
            "El léxico atestigua las formas: Épagomènes / Epagomenal Days / Epágomenos; no se muestran como título traducido en el sitio para preservar el elemento canónico.",
            "Dos ideogramas atestiguados: conceptual y funcional.",
            "Número canónico: 5, o 6 según amplitud.",
            "Función: convertir el exceso en paso y volver habitable el umbral."
        ],
        "cta_translate": "Proponer una traducción del concepto"
    }
};
  function fb(lang){ return FALLBACK[lang] || FALLBACK.fr; }

  function setPressed(root, lang){
    var btns = root.querySelectorAll('.po-langbtn');
    for (var i=0;i<btns.length;i++){
      var btnLang = normLang(btns[i].getAttribute('data-po-lang') || 'fr');
      btns[i].setAttribute('aria-pressed', btnLang === lang ? 'true' : 'false');
    }
  }

  function setCTA(root, lang){
    setSlotText(root, 'cta_translate', fb(lang).cta_translate);
  }

  function renderRoot(root, lang){
    var T = fb(lang);
    setSlotText(root, 'title', T.title);
    setSlotHTML(root, 'kicker', T.kicker);
    setSlotImgSrc(root, 'title_img', T.chip_urls[0], T.title);
    setSlotText(root, 'h_def', T.h_def);
    setSlotText(root, 'chip_1', T.chips[0]);
    setSlotText(root, 'chip_2', T.chips[1]);
    setSlotImgSrc(root, 'chip_1_img', T.chip_urls[0], T.chips[0]);
    setSlotImgSrc(root, 'chip_2_img', T.chip_urls[1], T.chips[1]);
    setSlotHTML(root, 'def_short', T.def_short);
    setSlotHTML(root, 'def_long', T.def_long);
    setSlotText(root, 'h_features', T.h_features);
    setSlotText(root, 'h_questions', T.h_questions);
    setSlotText(root, 'hint_fold', T.hint_fold);
    setSlotText(root, 'hint_fold2', T.hint_fold);
    setSlotText(root, 'h_family', T.h_family);
    setSlotText(root, 'hint_fold3', T.hint_fold);
    setSlotText(root, 'h_wordbuild', T.h_wordbuild);
    setSlotText(root, 'hint_fold4', T.hint_fold);
    renderListInto(root, 'features', T.features);
    renderListInto(root, 'questions', T.questions);
    setSlotHTML(root, 'example_box', T.example_box);
    setSlotHTML(root, 'family_1', T.family_1);
    setSlotHTML(root, 'family_2', T.family_2);
    renderWordBlocks(root, 'wordbuild_blocks', T.word_blocks);
    renderListInto(root, 'wordbuild_notes', T.word_notes);
    setCTA(root, lang);
    setPressed(root, lang);
    protectKeywordsInElement(root);
  }

  function wireButtons(root){
    if (!root || root.__poLangBound) return;
    root.__poLangBound = true;
    var btns = root.querySelectorAll('.po-langbtn');
    for (var i=0;i<btns.length;i++){
      btns[i].addEventListener('click', function(){
        var lang = normLang(this.getAttribute('data-po-lang') || 'fr');
        applyLangEverywhere(lang);
      });
    }
  }

  function lexiconLooksReady(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) return true;
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
    }catch(e){}
    return false;
  }

  /* ====================== AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL ====================== */

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:'', lang:'fr', voice:null };
  var AUDIO_UI = {
    fr: { general: 'Écouter le texte', block: 'Écouter ce bloc', stop: 'Arrêter la lecture' },
    en: { general: 'Listen to the text', block: 'Listen to this section', stop: 'Stop playback' },
    es: { general: 'Escuchar el texto', block: 'Escuchar este bloque', stop: 'Detener la lectura' }
  };

  function audioUI(lang){ var L = normLang(lang); return AUDIO_UI[L] || AUDIO_UI.fr; }
  function getAudioRoots(){ return getTargetBlocks(); }
  function getDetailBlocks(root){ return root ? Array.prototype.slice.call(root.querySelectorAll('.po-lex-details') || []) : []; }

  function getTextValue(el){
    if (!el) return '';
    var txt = '';
    try{ txt = el.textContent || el.innerText || ''; }catch(e){ txt = ''; }
    return clampStr(txt).replace(/\s+/g, ' ').trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn');
    for (var i=0;i<btns.length;i++) if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ['title', 'kicker', 'h_def', 'def_short', 'def_long'];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join('. ');
  }

  function collectDetailText(detail){
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title') || detail.querySelector('.po-lex-summary');
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);
    var clone = detail.cloneNode(true);
    var summary = clone.querySelector('.po-lex-summary');
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);
    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join('. ');
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, ' ').trim();
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = '';
    for (var i=0;i<pieces.length;i++){
      var piece = clampStr(pieces[i]).trim();
      if (!piece) continue;
      if (((current ? current + ' ' : '') + piece).length > 220){
        if (current) out.push(current.trim());
        if (piece.length > 220){
          var words = piece.split(/\s+/);
          var acc = '';
          for (var j=0;j<words.length;j++){
            var w = words[j];
            if (!w) continue;
            var next = acc ? (acc + ' ' + w) : w;
            if (next.length > 220){
              if (acc) out.push(acc.trim());
              acc = w;
            }else acc = next;
          }
          current = acc || '';
        }else current = piece;
      }else current = current ? (current + ' ' + piece) : piece;
    }
    if (current) out.push(current.trim());
    return out;
  }

  function getVoices(){ try{ return PO_AUDIO_SYNTH ? (PO_AUDIO_SYNTH.getVoices() || []) : []; }catch(e){ return []; } }
  function pickVoiceForLang(lang){
    var voices = getVoices();
    if (!voices.length) return null;
    var target = normLang(lang);
    var targets = target === 'fr' ? ['fr', 'fr-fr', 'fr_ca', 'fr-ca'] : target === 'en' ? ['en', 'en-us', 'en-gb'] : ['es', 'es-es', 'es-mx', 'es-us'];
    var i, v, vl;
    for (i=0;i<voices.length;i++){
      v = voices[i];
      vl = clampStr(v.lang).toLowerCase();
      if (targets.indexOf(vl) !== -1) return v;
    }
    for (i=0;i<voices.length;i++){
      v = voices[i];
      vl = clampStr(v.lang).toLowerCase();
      if (vl.indexOf(target) === 0) return v;
    }
    return voices[0] || null;
  }
  function getSpeechLangCode(lang){ var L = normLang(lang); if (L === 'en') return 'en-US'; if (L === 'es') return 'es-ES'; return 'fr-FR'; }

  function ensureAudioStyles(){
    if (document.getElementById('po-axis-audio-styles')) return;
    var style = document.createElement('style');
    style.id = 'po-axis-audio-styles';
    style.textContent =
      '.po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;}' +
      '.po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid currentColor;background:transparent;color:inherit;padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;line-height:1.2;transition:opacity .2s ease,transform .2s ease;}' +
      '.po-axis-audio-btn:hover{transform:translateY(-1px);}' +
      '.po-axis-audio-btn[aria-pressed="true"]{font-weight:600;}' +
      '.po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;}' +
      '@media (max-width:640px){.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}';
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role === 'general' ? 'general' : 'detail');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('translate', 'yes');
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector('.po-lex-panel');
    if (panel){
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap){
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap';
        generalWrap.setAttribute('data-po-audio-role', 'general');
        var generalBtn = createAudioButton('general');
        generalWrap.appendChild(generalBtn);

        var meta = root.querySelector('.po-axis-meta');
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetail = panel.querySelector('.po-lex-details');

        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        }else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        }else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        }else panel.appendChild(generalWrap);
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var detail = details[i];
      var summary = detail.querySelector('.po-lex-summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"]');
      if (!btn){
        btn = createAudioButton('detail');
        summary.appendChild(btn);
      }
      btn.setAttribute('data-po-audio-index', String(i));
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang);
    var activeRoot = (PO_AUDIO_STATE.root === root);
    var activeKey = PO_AUDIO_STATE.activeKey;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = btn.getAttribute('data-po-audio-role') || 'detail';
      var idx = parseInt(btn.getAttribute('data-po-audio-index'), 10);
      var key = role === 'general' ? 'general' : ('detail:' + (isNaN(idx) ? -1 : idx));
      var isActive = activeRoot && activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending);
      btn.textContent = isActive ? ui.stop : (role === 'general' ? ui.general : ui.block);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  function openDetailForPlayback(detail){
    if (!detail) return;
    try{ if (typeof detail.open !== 'undefined') detail.open = true; }catch(e){}
    try{ detail.setAttribute('open', 'open'); }catch(_e){}
  }

  function stopAudio(){
    try{ if (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    var roots = getAudioRoots();
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.voice = null;
    PO_AUDIO_STATE.lang = getLang();
    for (var i=0;i<roots.length;i++) refreshAudioLabels(roots[i], getLang());
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);
    if (role === 'general'){
      units.push({ role:'general', index:-1 });
      for (var i=0;i<details.length;i++) units.push({ role:'detail', index:i });
      return units;
    }
    var start = (typeof index === 'number' && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++) units.push({ role:'detail', index:j });
    return units;
  }

  function getTextForUnit(root, unit){
    if (!root || !unit) return '';
    if (unit.role === 'general') return collectGeneralText(root);
    var details = getDetailBlocks(root);
    var detail = details[unit.index];
    if (!detail) return '';
    openDetailForPlayback(detail);
    return collectDetailText(detail);
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      playCurrentUnit(true);
      return;
    }
    var chunk = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!chunk){ speakNextChunk(); return; }
    var utter = new SpeechSynthesisUtterance(chunk);
    utter.lang = getSpeechLangCode(PO_AUDIO_STATE.lang);
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.rate = 1;
    utter.pitch = 1;
    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };
    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ speakNextChunk(); }
  }

  function playCurrentUnit(fromNext){
    if (!PO_AUDIO_STATE.root) return;
    if (!fromNext && PO_AUDIO_STATE.unitPos < 0) PO_AUDIO_STATE.unitPos = 0;
    if (fromNext) PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){ stopAudio(); return; }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    var text = getTextForUnit(PO_AUDIO_STATE.root, unit);
    var chunks = splitTextForSpeech(text);
    if (!chunks.length){ playCurrentUnit(true); return; }
    PO_AUDIO_STATE.chunks = chunks;
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = unit.role === 'general' ? 'general' : ('detail:' + unit.index);
    refreshAudioLabels(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang);
    speakNextChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio();
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute('data-po-audio-role') || 'detail';
        var index = parseInt(this.getAttribute('data-po-audio-index'), 10);
        var key = role === 'general' ? 'general' : ('detail:' + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){
          stopAudio();
          return;
        }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === 'function'){
      PO_AUDIO_SYNTH.addEventListener('voiceschanged', function(){
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  }catch(e){}

  function applyLangEverywhere(lang){
    lang = normLang(lang);
    storeLang(lang);
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++){
      renderRoot(roots[i], lang);
      wireButtons(roots[i]);
    }
    initAudioEverywhere(lang);
    notifyLocaleChanged();
  }

  function init(){
    applyLangEverywhere(getLang());
    window.addEventListener('po:lexicon-ready', function(){
      __PO_PROTECT_CACHE__.key = '';
      __PO_PROTECT_CACHE__.re = null;
      applyLangEverywhere(getLang());
    });
    if (!lexiconLooksReady()){
      var tries = 0;
      var maxTries = 80;
      var timer = setInterval(function(){
        tries++;
        if (lexiconLooksReady() || tries >= maxTries){
          clearInterval(timer);
          __PO_PROTECT_CACHE__.key = '';
          __PO_PROTECT_CACHE__.re = null;
          applyLangEverywhere(getLang());
        }
      }, 100);
    }
  }

  window.PoKatupirsia9EpagomeneTextsFR_EN_ES_20260327 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };

  try{
    if (!window.GoodyTwinLang){
      window.GoodyTwinLang = { init:init, getLang:getLang, setLang:applyLangEverywhere };
    }else{
      if (typeof window.GoodyTwinLang.getLang !== 'function') window.GoodyTwinLang.getLang = getLang;
      if (typeof window.GoodyTwinLang.setLang !== 'function') window.GoodyTwinLang.setLang = applyLangEverywhere;
      if (typeof window.GoodyTwinLang.init !== 'function') window.GoodyTwinLang.init = init;
    }
  }catch(e){}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
